export default __webpack_public_path__ + "static/media/greenswirl.2134ae1b.svg";